import { EarlyBirdOfferListState } from "app/pages/EarlyBirdOfferList/modules/EarlyBirdOfferList/state";

function getRoot(state: any): EarlyBirdOfferListState {
    return state.earlyBirdOfferList;
}

export function getOffers(state: any) {
    return getRoot(state).offers;
}

export function getDivisionId(state: any) {
    return getRoot(state).divisionId;
}